import React from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom";

StaticOverviewTableItem.propTypes = {
    item: PropTypes.object
}

function StaticOverviewTableItem(props) {
    const {item} = props
    const {actions} = item

    return (
        <tr className='StaticOverviewTableItem'>
            <td className="Name">
                <Link
                    to={{
                        pathname: "/users-statics-detail",
                        search: `user=${item.user}`
                    }}
                >
                    {item.user}
                </Link>
            </td>
            <td className="smallStaticCol">{actions.mark_as_printed || ''}</td>
            <td className="StaticCol">{actions.updated_status_confirmed || ''}</td>
            <td className="StaticCol">{actions.mark_qc_after_transferred_error || ''}</td>
            <td className="StaticCol">{actions.scan_to_check || ''}</td>
            <td className="StaticCol">{actions.mark_as_qc_1st_3d || ''}</td>
            <td className="StaticCol">{actions.mark_as_qc || ''}</td>
            <td className="StaticCol">{actions.mark_qc_completed_error || ''}</td>
            <td className="StaticCol">{actions.updated_status_labelled || ''}</td>
            <td className="StaticCol">{actions.updated_status_packaged || ''}</td>
            <td className="StaticCol">{actions.scan_to_print_qr || ''}</td>
            <td className="StaticCol">{actions.updated_status_designed || ''}</td>
            <td className="StaticCol">{actions.updated_status_embroidered || ''}</td>
            <td className="StaticCol">{actions.updated_status_finish_periods || ''}</td>
        </tr>
    )

}

export default StaticOverviewTableItem
